import { useCallback } from "react"
import {
  getExpiresAt,
  getLoading,
  getRoles,
  getToken,
  getTokenAvailable,
  getUserId,
} from "./slice"
import { getRefreshToken } from "./refreshTokenStorage"
import { useSelector } from "@/base/store"
import { useTokenRefreshMutation } from "@/base/baseApi"

const ALMOST_EXPIRED = 10_000 // ms

const useAuth = () => {
  const token = useSelector(getToken)
  const expiresAt = useSelector(getExpiresAt)
  const [tokenRefresh] = useTokenRefreshMutation()

  const getFreshToken = useCallback(async () => {
    if (!expiresAt) {
      return null
    }

    if (expiresAt - Date.now() >= ALMOST_EXPIRED) {
      return token
    }

    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      return null
    }

    return (await tokenRefresh(refreshToken).unwrap()).token
  }, [expiresAt, token, tokenRefresh])

  return {
    userId: useSelector(getUserId),
    roles: useSelector(getRoles),
    token,
    isLoading: useSelector(getLoading),
    isAuthenticated: useSelector(getTokenAvailable),
    getFreshToken,
  }
}

export default useAuth
